// 面访 按调查员查询
export const visitorSheetListOptions = {
  column: [
    {
      width: 170,
      label: '调查员姓名',
      value: 'executorName',
      fixed: true
    },
    {
      width: 170,
      label: '手机号',
      value: 'executorPhone'
    },
    {
      width: 210,
      label: '任务名称',
      value: 'executionName'
    },
    {
      width: 110,
      label: '结算状态',
      value: 'settleStatus'
    },
    {
      width: 210,
      label: '有效答卷',
      value: 'effectiveQuantity'
    },
    {
      width: 150,
      label: '未结算',
      value: 'notInitiatedQuantity'
    },
    {
      label: '结算中',
      value: 'settlingQuantity'
    },
    {
      label: '已结算',
      value: 'settledQuantity'
    },
    {
      width: 105,
      label: '答卷单价（元）',
      value: 'executionSingleAmount',
      renderHeader: (h, { column, $index }) => {
        return h('div', { class: 'tips', style: { display: 'inline' } }, [
          h('span', column.label),
          h(
            'el-tooltip',
            {
              style: {
                position: 'relative',
                left: '18px',
                top: '-25px'
              },
              attrs: {
                class: 'item',
                effect: 'light',
                content: '任务设置的答卷单价',
                placement: 'top-start'
              }
            },
            [
              h('img', {
                attrs: {
                  src: process.env.BASE_URL + 'img/tips_red.png',
                  width: 14
                }
              })
            ]
          )
        ])
      }
    },
    {
      width: 105,
      label: '结算单价（元）',
      value: 'realYuanAmount',
      renderHeader: (h, { column, $index }) => {
        return h('div', { class: 'tips', style: { display: 'inline' } }, [
          h('span', column.label),
          h(
            'el-tooltip',
            {
              style: {
                position: 'relative',
                left: '20px',
                top: '-25px'
              },
              attrs: {
                class: 'item',
                effect: 'light',
                content: '未结算答卷的结算单价',
                placement: 'top-start'
              }
            },
            [
              h('img', {
                attrs: {
                  src: process.env.BASE_URL + 'img/tips_red.png',
                  width: 14
                }
              })
            ]
          )
        ])
      }
    },
    {
      width: 100,
      label: '调价金额（元）',
      value: 'adjustYuanAmount'
    },
    {
      width: 330,
      label: '调价说明',
      value: 'adjustDescribe'
    },
    {
      label: '操作',
      value: 'opt',
      width: 150,
      fixed: 'right'
    }
  ]
}
